// frontend/src/components/esim/ESIMOrdersTable.js
import React from "react";
import GenericTable from "../GenericTable";
import ESIMOrderRow from "./ESIMOrderRow";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Comment, Visibility } from "@mui/icons-material"; // Import Visibility icon

const ESIMOrdersTable = ({
  orders,
  loading,
  onAction,
  onSendSMS,
  onViewDetails, // Add this prop
  pagination,
}) => {
  const { t } = useTranslation();

  const formatDate = (date) => {
    if (!date) return t("common.noData");

    try {
      const formattedDate = new Date(date);
      return formattedDate instanceof Date && !isNaN(formattedDate)
        ? formattedDate.toLocaleString()
        : t("common.noData");
    } catch (error) {
      console.error("Date formatting error:", error);
      return t("common.noData");
    }
  };

  const columns = [
    {
      id: "status",
      label: t("esim.orders.table.status"),
      sortable: true,
    },
    {
      id: "profile",
      label: t("esim.orders.table.profile"),
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* <Avatar
            src={params.row.profile?.logoUrl}
            sx={{ width: 24, height: 24 }}
          >
            {params.row.profile?.name?.[0] || params.row.user?.username?.[0]}
          </Avatar> */}
          <Typography>
            {params.row.profile?.name || params.row.user?.username}
          </Typography>
        </Box>
      ),
    },
    {
      id: "customerName",
      label: t("esim.orders.table.customerName"),
      sortable: true,
    },
    {
      id: "customerEmail",
      label: t("esim.orders.table.customerEmail"),
      sortable: true,
    },
    {
      id: "orderNo",
      label: t("esim.orders.table.orderNo"),
      sortable: true,
    },
    {
      id: "iccid",
      label: t("esim.orders.table.iccid"),
      sortable: true,
    },
    {
      id: "package",
      label: t("esim.orders.table.package"),
      sortable: true,
    },
    {
      id: "dataUsage",
      label: t("esim.orders.table.dataUsage"),
      align: "right",
      sortable: true,
    },
    {
      id: "purchaseDate",
      label: t("esim.orders.table.purchaseDate"),
      sortable: true,
      renderCell: (params) => formatDate(params.row.createdAt),
    },
    {
      id: "expiry",
      label: t("esim.orders.table.expiry"),
      align: "right",
      sortable: true,
      renderCell: (params) => formatDate(params.row.expiryDate),
    },
    {
      id: "notes",
      label: t("esim.orders.table.notes"),
      renderCell: (params) =>
        params.row.notes ? (
          <Tooltip title={params.row.notes}>
            <IconButton size="small">
              <Comment fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : (
          "-"
        ),
    },
    {
      id: "actions",
      label: t("common.actions.actions"),
      align: "center",
      renderCell: (row) => (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
          <Tooltip title={t("common.actions.viewDetails")}>
            <IconButton size="small" onClick={() => onViewDetails(row)}>
              <Visibility />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <GenericTable
      columns={columns}
      data={orders}
      loading={loading}
      emptyMessage={t("esim.orders.noOrders")}
      pagination={pagination}
      renderRow={(order) => (
        <ESIMOrderRow
          key={order.id}
          order={order}
          onAction={onAction}
          onSendSMS={onSendSMS}
          onViewDetails={onViewDetails} // Pass down the handler
        />
      )}
    />
  );
};

export default ESIMOrdersTable;
